export const MULTI_PCB_TARGET = 'Multi-PCB Target'
